import api from '@core-custom/api/api'
import apiConfig from '@core-custom/api/apiConfig'
import i18n from '@/libs/i18n'
import defaultState from './defaultState'

export default {
  namespaced: true,
  state: defaultState,
  getters: {
    listviewData: state => state.listviewData.value,
    data: state => ({
      init: state.init.value,
      loading: state.loading.value,
      perPage: state.perPage.value,
      totalRows: state.totalRows.value,
      currentPage: state.currentPage.value,
      searchTxt: state.searchTxt.value,
      totalFieldsFilter: state.totalFieldsFilter.value,
      orderBy: state.orderBy.value,
      showListviewFilter: state.showListviewFilter.value,
      showListview: () => {
        if (state.totalRows.value > 0) {
          return true
        }

        return false
      },
      showPager: () => {
        if (state.totalRows.value > state.perPage.value) {
          return true
        }

        return false
      },
    }),
    txt: state => ({
      searchPlaceholder: state.txtSearchPlaceholder,
      loading: state.txtLoading,
      default: state.txtDefault,
      notFind: state.txtNotFind,
    }),
    fieldsOrder: state => state.fieldsOrder,
  },
  mutations: {
    resetState(state) {
      Object.assign(state, defaultState)
    },
    setListviewData(state, payload) {
      state.listviewData.value = payload
    },
    setTotalRows(state, payload) {
      state.totalRows.value = payload
    },
    setLoadingListview(state, payload) {
      state.loading.value = payload
    },
    setListviewInit(state, payload) {
      state.init.value = payload
    },
    setCurrentPage(state, payload) {
      state.currentPage.value = payload
    },
    setSearchTxt(state, payload) {
      state.searchTxt.value = payload
    },
    setListviewOrderBy(state, payload) {
      state.orderBy.value = {
        sort: payload.sort,
        column: payload.column,
      }
    },
    addFilterSelectedTotalFields(state) {
      state.totalFieldsFilter.value += 1
    },
    resetFilterSelectedTotalFields(state) {
      state.totalFieldsFilter.value = 0
    },
    setShowListviewFilter(state, payload) {
      state.showListviewFilter.value = payload
    },
  },
  actions: {

    async loadListviewData({
      state, commit, dispatch, rootGetters,
    }, payload) {
      if (rootGetters['crm_leads_form/loaded'] === true) {
        await dispatch('request/cancelTokensPendingByUrl', 'leads/loadNotesByLead', { root: true })
      }

      const request = await new Promise((resolve, reject) => {
        commit('resetFilterSelectedTotalFields')

        const formData = new FormData()
        formData.append('sw044s02', rootGetters['crm_leads_form/keyReg'])
        formData.append('sw044s07', rootGetters['crm_leads_form/dynamicIDForm'])
        formData.append('start', ((state.currentPage.value - 1) * state.perPage.value))
        formData.append('length', state.perPage.value)

        if (state.searchTxt.value !== '') {
          formData.append('fSearch', state.searchTxt.value)
          commit('addFilterSelectedTotalFields')
        }

        if (state.orderBy.value.column !== undefined) {
          formData.append('orderByColumn', state.orderBy.value.column)
        }

        if (state.orderBy.value.sort !== undefined) {
          formData.append('orderBySort', state.orderBy.value.sort)
        }

        if (!!payload && (payload.loadingDisable !== undefined) && (payload.loadingDisable === true)) {
          commit('setListviewInit', 1)
        } else {
          commit('setListviewData', [])
          commit('setTotalRows', 0)
          commit('setLoadingListview', true)
          commit('setListviewInit', 1)
        }

        api.post(`${apiConfig.url_base_api}leads/loadNotesByLead`, formData)
          .then(response => {
            try {
              if (response.data !== undefined) {
                if ('all' in response.data) {
                  commit('setListviewData', response.data.all)
                }

                commit('setTotalRows', response.data.total)
                commit('setLoadingListview', false)
                commit('setListviewInit', 0)

                if (!!payload && (payload.init !== undefined) && (payload.init === true) && (response.data.total > 0)) {
                  commit('setShowListviewFilter', true)
                }

                resolve(true)
              } else {
                reject(new Error(i18n.t('Problema ao carregar as notas')))
              }
            } catch (error) {
              if ((error.response !== undefined) && (error.response.status !== undefined)) {
                reject(new Error(i18n.t('Problema ao carregar as notas')))
              }
            }
          })
          .catch(error => {
            if ((error.response !== undefined) && (error.response.status !== undefined)) {
              reject(new Error(i18n.t('Problema ao carregar as notas')))
            }
          })
      })

      return request
    },

    listviewFilterOrderBy({ state, commit, dispatch }, field) {
      if ((!!state.orderBy.value.column) && (state.orderBy.value.column === field)) {
        if (state.orderBy.value.sort === 'asc') {
          commit('setListviewOrderBy', {
            sort: 'desc',
            column: field,
          })
        } else {
          commit('setListviewOrderBy', {
            sort: 'asc',
            column: field,
          })
        }
      } else {
        commit('setListviewOrderBy', {
          sort: 'asc',
          column: field,
        })
      }

      commit('setCurrentPage', 1)

      return dispatch('loadListviewData')
    },

    setCurrentPage({ commit, dispatch }, value) {
      commit('setCurrentPage', value)
      return dispatch('loadListviewData')
    },

    setSearchTxt({ commit, dispatch }, value) {
      commit('setSearchTxt', value)
      commit('setCurrentPage', 1)
      return dispatch('loadListviewData', { loadingDisable: true })
    },

    async deleteSW044({ rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('sw044s01', payload.sw044s01)
        formData.append('sw044s02', rootGetters['crm_leads_form/keyReg'])
        formData.append('sw044s07', rootGetters['crm_leads_form/dynamicIDForm'])

        api.post(`${apiConfig.url_base_api}leads/deleteNotes`, formData)
          .then(response => {
            try {
              if (typeof response.data === 'object') {
                if (response.data.error === 1) {
                  reject(new Error(response.data.msg))
                } else {
                  resolve({ message: response.data.msg })
                }
              } else {
                reject(new Error(i18n.t('Problema ao eliminar a nota')))
              }
            } catch (error) {
              if ((error.response !== undefined) && (error.response.status !== undefined)) {
                reject(new Error(i18n.t('Problema ao eliminar a nota')))
              }
            }
          })
          .catch(error => {
            if ((error.response !== undefined) && (error.response.status !== undefined)) {
              reject(new Error(i18n.t('Problema ao eliminar a nota')))
            }
          })
      })
    },

    async saveSW044({ rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        let urlSave = ''

        if (payload.sw044s01 !== null) {
          urlSave = 'leads/saveEditNotes'

          formData.append('sw044s01', payload.sw044s01)
          formData.append('sw044s03', payload.sw044s03 || '')
        } else {
          urlSave = 'leads/saveNotes'
          formData.append('sw044s02', rootGetters['crm_leads_form/keyReg'] || '')
          formData.append('sw044s07', rootGetters['crm_leads_form/dynamicIDForm'] || '')
          formData.append('sw044s03', payload.sw044s03 || '')
        }

        formData.append('sw044s11', payload.sw044s11 || '')

        api.post(`${apiConfig.url_base_api}${urlSave}`, formData)
          .then(response => {
            try {
              if (typeof response.data === 'object') {
                if (response.data.error === 1) {
                  reject(new Error(response.data.msg))
                } else {
                  resolve({ message: response.data.msg })
                }
              } else {
                reject(new Error(i18n.t('Problema ao guardar a nota')))
              }
            } catch (error) {
              if ((error.response !== undefined) && (error.response.status !== undefined)) {
                reject(new Error(i18n.t('Problema ao guardar a nota')))
              }
            }
          })
          .catch(error => {
            if ((error.response !== undefined) && (error.response.status !== undefined)) {
              reject(new Error(i18n.t('Problema ao guardar a nota')))
            }
          })
      })
    },

    async editSW044(state, payload) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('sw044s01', payload.sw044s01 || '')

        api.post(`${apiConfig.url_base_api}leads/editNotes`, formData)
          .then(response => {
            try {
              if (typeof response.data.data === 'object') {
                if ('sw044' in response.data.data) {
                  resolve(response.data.data.sw044)
                } else {
                  reject(new Error(i18n.t('Problema ao editar a nota')))
                }
              } else {
                reject(new Error(i18n.t('Problema ao editar a nota')))
              }
            } catch (error) {
              if ((error.response !== undefined) && (error.response.status !== undefined)) {
                reject(new Error(i18n.t('Problema ao editar a nota')))
              }
            }
          })
          .catch(error => {
            if ((error.response !== undefined) && (error.response.status !== undefined)) {
              reject(new Error(i18n.t('Problema ao editar a nota')))
            }
          })
      })
    },

  },
}
